// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'check-solid';

export const Component = () => (
  <path d='M12.5 3.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm-1.454 12.861L6.75 12.25l-1.25 1.5 5.594 5.485 8.406-9.75L18 8.25z' />
);

export const viewBox = '0 0 25 25';
